<!-- Layout.vue -->
<template>
  <div>
    <Menu />  <!-- 显示菜单 -->
    <router-view />  <!-- 显示具体页面内容 -->
  </div>
</template>

<script>
import Menu from "@/components/Menu";  // 导入菜单组件

export default {
  components: {
    Menu,
  },
};
</script>
